import View from './Settings';
import enhancer from './Settings.enhancer';

const Settings = enhancer(View);

export default Settings;
